// extracted by mini-css-extract-plugin
export default {"image":"auth_image__dh8j9","bannerImage":"auth_bannerImage__ABSNb","childSection":"auth_childSection__pDowl","logo":"auth_logo__CO9rJ"};